/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipes_OfflineInputs */

const en_recipes_offline = /** @type {(inputs: Recipes_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're offline and no recipes are saved on this device yet.`)
};

const de_recipes_offline = /** @type {(inputs: Recipes_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du bist offline und auf diesem Gerät sind noch keine Rezepte gespeichert.`)
};

/**
* | output |
* | --- |
* | "You're offline and no recipes are saved on this device yet." |
*
* @param {Recipes_OfflineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipes_offline = /** @type {((inputs?: Recipes_OfflineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipes_OfflineInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipes_offline(inputs)
	return en_recipes_offline(inputs)
});